import classes from './pinned-image-styles.module.css'

const PinnedImage = (props) => {
    var bg = require('../assets/images/characters/chandler.png')
    const { winner } = props
    if (winner === 'chandler') {
        bg = require('../assets/images/characters/chandler.png')
    }
    else if (winner === 'monica') {
        bg = require('../assets/images/characters/monica.png')
    }
    else if (winner === 'rachel') {
        bg = require('../assets/images/characters/rachel.png')
    }
    else if (winner === 'ross') {
        bg = require('../assets/images/characters/ross.png')
    }
    else if (winner === 'joey') {
        bg = require('../assets/images/characters/joey.png')
    }
    return (<div style={{ marginRight: '5%' ,display:'flex',justifyContent:'center',alignItems:'center',width:'100%'}}>
        <div className={classes.imageContainer}
            style={{
                
                backgroundImage: "url(" + bg + ")",
                alignSelf: 'center',
            }}
        >
        </div>
    </div >)
}
export default PinnedImage;